module.exports = __webpack_public_path__ + "static/media/21.7ff0a486.webp";